import { getListTransform, getDetailTransform } from 'helpers/transformResponse';
import types from './types';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  detail: {},
  parentActions: [],
  loading: true,
  buttonLoading: false,
  parentActionsLoading: false,
  parentActionsSaving: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.LIST_FETCHED:
      return {
        ...state,
        list: getListTransform(action.payload.data) || INITIAL_STATE.list,
        loading: false,
      };
    case types.ITEM_DETAIL:
      return {
        ...state,
        detail: getDetailTransform(action.payload.data) || INITIAL_STATE.detail,
        loading: false,
      };
    case types.PARENT_ACTIONS_FETCHED:
      return {
        ...state,
        parentActions: action.payload || [],
        parentActionsLoading: false,
      };
    case types.LIST_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    case types.BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };
    case types.PARENT_ACTIONS_LOAD:
      return {
        ...state,
        parentActionsLoading: action.payload,
      };
    case types.PARENT_ACTIONS_SAVE_LOAD:
      return {
        ...state,
        parentActionsSaving: action.payload,
      };
    default:
      return state;
  }
};
